<div class="login-form-wrapper main-container">
    <div class="container-xs p-3 p-sm-4">
        <img class="logo" src="assets/images/logo_high_res.jpg">
        <form class="login-form p-4 p-sm-5" style="max-width: 370px">
            <div class="d-flex align-items-center mb-3 mt-n2">
                <!--<h1>{{ 'login.panel' | translate }}</h1>-->
                <div class="dropdown ihost-dropdown ihost-dropdown-lang">
                    <button class="btn btn-sm dropdown-toggle no-caret" type="button" id="dropdownMenuButton"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img [src]="'assets/images/' + language.img"><span class="ps-1">{{language.shortText}}</span>
                    </button>
                    <div class="dropdown-menu ihost-dropdown-menu dropdown-menu-right ihost-dropdown-menu-right">
                        <a *ngFor="let lang of languages" class="dropdown-item ihost-dropdown-item"
                            (click)="setLanguage(lang)">
                            <img [src]="'assets/images/' + lang.img"><span class="ps-1">{{lang.text}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form-col">
                <input type="text" class="ihost-control" placeholder="Username" name="username" autocomplete="username"
                    [(ngModel)]="username">
                <div [class]="'password-wrapper' + (showPassword ? ' password-show' : '')">
                    <input [type]="showPassword == false ? 'password' : 'text'" class="ihost-control"
                        placeholder="Password" name="password" autocomplete="current-password" [(ngModel)]="password">
                    <a class="password-type-toggle">
                        <i (click)="showPassword = !showPassword" class="ihost-icon-eye"></i>
                    </a>
                </div>
                <label *ngIf="error != null && error != ''" class="error-label mb-2">{{ error }}</label>
            </div>
            <div class="d-grid">
                <a class="btn btn-main" (click)="login()">{{ 'login.label' | translate }}</a>
            </div>           
        </form>

        <div class="d-grid">
            <a class="help-link" (click)="help()">{{ 'menu.help' | translate }}...</a>
        </div>
    </div>
</div>